<template>
  <div class="w100m">
    <div class="w100 flexVC" style="padding-top: 80px;" v-if="$store.state.isPc">
      <div class="title">{{title}}</div>
      <div class="item flexHC marB32" v-for="item in partyData" @click="navLink(item.link,item.year)">
        <div class="left flexVC2">
          <img src="../../assets/images/icon_activity_comma.png" class="item-comma">
          <div class="item-year marT50">-&nbsp;{{item.year}}&nbsp;-</div>
          <div class="item-title marT15">{{item.slogan}}</div>
          <div class="item-btn" style="margin-top: 65px;">查看全文</div>
        </div>
        <div class="right pR">
          <el-image
            class="item-img"
            :src="item.coverUrl"
            :fit="cover"></el-image>
        </div>

      </div>
      <div style="padding-bottom: 60px;"></div>
      <shape-footer></shape-footer>
    </div>
    <div class="w100m flexVC Bf0f2f5" style="padding-top: 1.30rem;" v-if="!$store.state.isPc">
      <div class="title-m">{{title}}</div>
      <div class="item-m flexHC marB32" v-for="item in partyData" @click="navLink(item.link,item.year)">
        <div class="left-m flexVC2">
          <img src="../../assets/images/icon_activity_comma.png" class="item-comma-m">
          <div class="item-year-m marT16m">-&nbsp;{{item.year}}&nbsp;-</div>
          <div class="item-title-m ">{{item.slogan}}</div>
<!--          <div class="item-btn" style="margin-top: 65px;">查看全文</div>-->
        </div>
        <div class="right-m pR">
          <el-image
            class="item-img-m"
            :src="item.coverUrl"
            :fit="cover"></el-image>
        </div>

      </div>
      <div style="padding-bottom: 60px;"></div>
      <shape-footer></shape-footer>
    </div>
  </div>
</template>

<script>
  import shapeFooter from '@/components/ShapeFooter'
  import {partyData, muscleData} from '@/utils/staticData'

  export default {
    name: "ActivityDetail",
    data() {
      return {
        isShow: true,
        cover: 'cover',
        partyData: [],
        title: '趁早PARTY历年回顾',
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      this.title = this.$route.query.type == 1 ? '趁早PARTY历年回顾' : 'SHAPEGIRL马甲线大赛历年回顾'
      this.partyData = this.$route.query.type == 1 ? partyData : muscleData
    },

    methods: {
      navLink(link,year) {
        if (this.$route.query.type == 1) {
          console.log('111111111111111')
          this.$router.push({
            path: '/partyDetail',
            query: {
              data: year,
            }
          })
        } else {
          if (!link) {
            return
          }
          window.location.href = link
        }
      }
    }
  }
</script>

<style scoped>

  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 80px;
    margin-bottom: 80px;
  }

  .item {
    width: calc(100% - 7.71vw - 8.06vw);
    min-width: 1000px;
    background: #000000;
    cursor: pointer;
  }

  .left {
    width: 33.34%;
    height: 400px;
  }

  .right {
    width: 66.66%;
    height: 400px;
  }

  .item-img{
    width: 100%;
    height: 400px;
  }

  .item-comma{
    width: 49px;
    height: 33px;
  }

  .item-year{
    font-size: 32px;
    font-family: DIN-Light, DIN;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.45);
  }

  .item-title{
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
  }

  .item-btn{
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.45);
  }
/********************************mobile***************************************/
  .title-m{
    font-size: 0.32rem;
    font-weight: 600;
    font-family: PingFangSC-Medium, PingFang SC;
    color: rgba(0, 0, 0, 0.85);
    /*margin-top: 0.6rem;*/
    margin-bottom: 0.6rem;
  }

  .item-m {
    width: calc(100% - 0.96rem);
    background: #000000;
    cursor: pointer;
  }

  .item-comma-m{
    width: 0.32rem;
    height: 0.21rem;
  }

  .item-img-m{
    width: 100%;
    height: 2.10rem;
  }

  .left-m {
    width: 33.34%;
    height: 2.10rem;
  }

  .right-m {
    width: 66.66%;
    height: 2.10rem;
  }

  .item-year-m{
    font-size: 0.24rem;
    font-family: DIN-Light, DIN;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.45);
  }

  .item-title-m{
    width: 1.50rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
  }

  .item-btn-m{
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.45);
  }

  .marT16m{
    margin-top: 0.16rem;
  }

/* **************************************************************** */


</style>



// WEBPACK FOOTER //
// src/page/activity/ActivityDetail.vue